const HASH_STORAGE_KEY = 'hash';
const HASH_SALT = 'bff-cadp-v1';

const toBase64 = (value: string): string => {
  return btoa(unescape(encodeURIComponent(value)));
};

const fromBase64 = (value: string): string => {
  return decodeURIComponent(escape(atob(value)));
};

export const encryptCpfToHash = (cpf: string): string | null => {
  const cpfDigits = String(cpf ?? '').replace(/\D/g, '');
  if (!cpfDigits) return null;
  try {
    const payload = `${HASH_SALT}:${cpfDigits.split('').reverse().join('')}`;
    return toBase64(payload);
  } catch {
    return null;
  }
};

export const decryptCpfFromHash = (hashValue: string): string | null => {
  try {
    const decoded = fromBase64(hashValue);
    const [salt, reversedCpf] = decoded.split(':');
    if (salt !== HASH_SALT || !reversedCpf) return null;
    const cpf = reversedCpf.split('').reverse().join('').replace(/\D/g, '');
    return cpf || null;
  } catch {
    return null;
  }
};

export const persistCpfHash = (cpf: string | null): void => {
  if (typeof window === 'undefined') return;
  if (!cpf) {
    window.localStorage.removeItem(HASH_STORAGE_KEY);
    return;
  }
  const encrypted = encryptCpfToHash(cpf);
  if (!encrypted) {
    window.localStorage.removeItem(HASH_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(HASH_STORAGE_KEY, encrypted);
};

export const readCpfFromHashStorage = (): string | null => {
  if (typeof window === 'undefined') return null;
  const hashValue = window.localStorage.getItem(HASH_STORAGE_KEY);
  if (!hashValue) return null;
  return decryptCpfFromHash(hashValue);
};

export const clearCpfHashStorage = (): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(HASH_STORAGE_KEY);
};
